import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const products = [
  {
    name: 'חבילת basic',
    desc: 'חבילה בסיסית בתשלום חודשי מתחדש',
    price: 'חינם',
  },
  { name: 'שבב חכם', desc: '', price: '89.99₪' },
];
const addresses = ['ז׳בוטינסקי 4', 'רמן גן', '00000', 'ישראל'];
const payments = [
  { name: 'סוג הכרטיס', detail: 'Visa' },
  { name: 'העל הכרטיס', detail: 'אברהם אלוני' },
  { name: 'מספר כרטיס', detail: 'xxxx-xxxx-xxxx-1234' },
  { name: 'תאריך תפוגה', detail: '04/2024' },
];

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(1, 0),
  },
  total: {
    fontWeight: 700,
  },
  title: {
    marginTop: theme.spacing(2),
  },
}));

export default function Review() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        סיכום הזמנה
      </Typography>
      <List disablePadding>
        {products.map(product => (
          <ListItem className={classes.listItem} key={product.name}>
            <ListItemText primary={product.name} secondary={product.desc} />
            <Typography variant="body2">{product.price}</Typography>
          </ListItem>
        ))}
        <ListItem className={classes.listItem}>
          <ListItemText primary="סה״כ לתשלום" />
          <Typography variant="subtitle1" className={classes.total}>
            89.99₪
          </Typography>
        </ListItem>
      </List>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom className={classes.title}>
            משלוח
          </Typography>
          <Typography gutterBottom>אברהם אלוני</Typography>
          <Typography gutterBottom>{addresses.join(', ')}</Typography>
        </Grid>
        <Grid item container direction="column" xs={12} sm={6}>
          <Typography variant="h6" gutterBottom className={classes.title}>
            פרטי תשלום
          </Typography>
          <Grid container>
            {payments.map(payment => (
              <React.Fragment key={payment.name}>
                <Grid item xs={6}>
                  <Typography gutterBottom>{payment.name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{payment.detail}</Typography>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <br />
      <FormControlLabel
        control={<Checkbox color="secondary" name="saveAddress" value="yes" />}
        label="אני מאשר/ת את התקנון ומדיניות הפרטיות"
      />
    </React.Fragment>
  );
}
